/**
 * Route definition for /manage
 * Renders the BatchUploadContainer (Management container) component.
 *
 * @module routes/manage
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import BatchUploadContainer from "@/containers/Management";

export const Route = createFileRoute('/$locale/manage')({
  component: Manage,
})

/**
 * Manage page component.
 * Renders the Management container for batch upload and management operations.
 *
 * @returns {React.ReactElement}
 */
function Manage() {


  return (
    <>
      <BatchUploadContainer/>
    </>
  )
}